export default __webpack_public_path__ + "static/media/enghien19.3c6dee39.jpg";